function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import { useParams } from 'react-router-dom';
import get from 'lodash/get';
import { Button as ChakraButton, Icon, icons, Text } from '@tapresearch/ui/components';
import { Buttons } from 'Shared/Button';
import * as SR from '../campaign/SurveyResults.styled';
import * as S from './CampaignResult.styled';
import { FieldingStats } from '../campaign/FieldingStats';
import Link from '../common/Link';
import { SurveyResultsWrapper } from '../campaign/Results';
export default function(param) {
    var results = param.results, campaign = param.campaign;
    var identifier = useParams().identifier;
    var firstResponse = get(results, 'fielding.first_response');
    var lastResponse = get(results, 'fielding.last_response');
    var completesCount = get(results, 'fielding.completes_count', 0);
    var tapSurveyIdentifier = get(campaign, 'tap_survey.identifier');
    var originalTotal = campaign.original_quotas_total;
    var resultsCsvUrl = get(campaign, 'project_export.results_csv_download_url') || "/insights_platform/data/".concat(identifier, ".csv");
    var questionsHash = get(results, 'questions', {});
    return /*#__PURE__*/ React.createElement(S.CampaignResult, null, /*#__PURE__*/ React.createElement(S.Body, null, /*#__PURE__*/ React.createElement(Text, {
        as: "h2",
        fontSize: "2xl",
        display: "flex",
        justifyContent: "space-around"
    }, campaign.name), /*#__PURE__*/ React.createElement(SR.SurveyResults, null, /*#__PURE__*/ React.createElement(SR.Header, null, /*#__PURE__*/ React.createElement(SR.HeaderLeft, null, /*#__PURE__*/ React.createElement(FieldingStats, {
        originalTotal: originalTotal,
        firstResponse: firstResponse,
        lastResponse: lastResponse,
        campaignStatus: campaign.status,
        completesCount: completesCount
    })), /*#__PURE__*/ React.createElement(SR.HeaderRight, null, completesCount > 0 && /*#__PURE__*/ React.createElement(Link, {
        to: resultsCsvUrl,
        external: true,
        download: true
    }, /*#__PURE__*/ React.createElement(ChakraButton, _object_spread_props(_object_spread({}, Buttons.PrimarySmall), {
        mr: 4,
        leftIcon: /*#__PURE__*/ React.createElement(Icon, {
            boxSize: 4,
            icon: icons.fi.DownloadCloud
        })
    }), "Responses")))), /*#__PURE__*/ React.createElement(SR.Body, null, completesCount > 0 ? /*#__PURE__*/ React.createElement(SurveyResultsWrapper, {
        tapSurveyIdentifier: tapSurveyIdentifier,
        campaignResultIdentifier: identifier,
        countryId: campaign.country_id,
        languageId: campaign.language_id,
        questionsHash: questionsHash
    }) : /*#__PURE__*/ React.createElement(SR.Panel, null, /*#__PURE__*/ React.createElement(Text, {
        fontWeight: 'medium',
        fontSize: 'xl',
        color: 'gray.400',
        as: "h3"
    }, "No responses gathered yet."))))));
};
